import {ObjectModelPermissionCapabilityType} from "~/enums/objectModelPermissionCapabilityType";
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import {Logger} from "~/services/logger";
import {IPermittee} from '~/interfaces/permitteeInterfaces'
import {PermitteeType} from '~/enums/permitteeType'
import {ObjectModelDefaultActionType} from '~/enums/objectModelDefaultActionType'
import ObjectModelAction from '~/models/objectModelActions/objectModelAction'
import {ObjectModelPermissionPermittableType} from '~/interfaces/objectModelInterfaces'
import ObjectModelRelation from "~/models/objectModelRelations/objectModelRelation";

export class ObjectModelPermissionDefinition {
  static ACTION_CAPABILITIES: ObjectModelPermissionCapabilityType[] = [
    ObjectModelPermissionCapabilityType.Enable,
  ];

  static PROPERTY_CAPABILITIES: ObjectModelPermissionCapabilityType[] = [
    ObjectModelPermissionCapabilityType.Edit,
  ];

  static RELATIONSHIP_CAPABILITIES: ObjectModelPermissionCapabilityType[] = [
    ObjectModelPermissionCapabilityType.ConnectOrSever,
  ];


  static capabilityTypesFor(permissionType: ObjectModelPermissionType): ObjectModelPermissionCapabilityType[] {
    switch (permissionType) {
      case ObjectModelPermissionType.Action:
        return this.ACTION_CAPABILITIES;
      case ObjectModelPermissionType.Property:
        return this.PROPERTY_CAPABILITIES;
      case ObjectModelPermissionType.Relationship:
        return this.RELATIONSHIP_CAPABILITIES;
      default:
        Logger.errorOnce('ObjectModelPermissionDefinition#capabilityTypesFor', `Unexpected permissionType: ${permissionType}`);
        break;
    }
  }

  static canCreate({ permittee, permittable }: { permittee: IPermittee, permittable: ObjectModelPermissionPermittableType }): boolean {
    if (!permittee || !permittable) return false
    switch (permittee.reference_type) {
      case PermitteeType.objectOwner:
        if (permittable instanceof ObjectModelAction) {
          return ![ObjectModelDefaultActionType.Create, ObjectModelDefaultActionType.Edit].includes(permittable.default_action_type)
        } else {
          return true
        }
      case PermitteeType.entityAccountRelation:
        if (permittable instanceof ObjectModelRelation) {
          // formats b45b83f0-474c-f0c6-e831-34f74374fe99-owner into pure client id
          const permitteeReferenceClientId = permittee.reference_id.split("-").slice(0, -1).join("-");
          const relationClientId = permittable.client_id;
          return permitteeReferenceClientId !== relationClientId;
        } else {
          return true;
        }
      default:
        return true
    }
  }
}